import { useQuery, useQueryClient } from 'react-query'

import { IUser } from '@monorepo/interfaces'
import { useAuth } from '../auth_module'
import { useApi } from './useApi'
import { useCallback } from 'react'

const QUERY_KEY = 'fetchUser'

export function useCurrentUser() {
  const { fetchUser } = useApi()
  const { isAuthenticated } = useAuth()
  const queryClient = useQueryClient()

  const clearUser = useCallback(() => {
    queryClient.setQueryData<IUser | undefined>(QUERY_KEY, undefined)
  }, [queryClient])

  return Object.assign(
    useQuery(QUERY_KEY, fetchUser, {
      refetchOnWindowFocus: true,
      enabled: isAuthenticated,
    }),
    { clearUser }
  )
}
